import IdentificationError from './IdentificationError';
class InvestorHasInvalidState extends IdentificationError {
    constructor(options) {
        super('The investor has an invalid state', options);
    }
}
export default InvestorHasInvalidState;
